import type { FastifyInstance } from 'fastify'
import type { ProfileController } from './profile.controller.js'
import { authMiddleware } from '../../middleware/auth.middleware.js'

export async function profileRoutes(app: FastifyInstance, controller: ProfileController) {
  app.addHook('onRequest', authMiddleware)

  app.get('/', controller.getProfile.bind(controller))
  app.get('/light', controller.getProfileLight.bind(controller))
  app.patch('/', controller.updateProfile.bind(controller))

  app.patch('/icon', controller.updateProfileIcon.bind(controller))

  app.patch('/preferences', controller.updatePreferences.bind(controller))
  app.post('/preferences/interaction', controller.recordInteraction.bind(controller))
  app.get('/preferences/recommendations', controller.getRecommendations.bind(controller))

  app.post('/sessions/revoke', controller.revokeSession.bind(controller))
  app.post('/data/export', controller.requestDataExport.bind(controller))
}
